// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M2.5 3.5H13.5M2.5 8H6.25M2.5 12.5H6.25',
  'M13.5 10.25C13.5 11.63 12.38 12.75 11 12.75C9.62 12.75 8.5 11.63 8.5 10.25C8.5 8.87 9.62 7.75 11 7.75C12.38 7.75 13.5 8.87 13.5 10.25Z',
  'M12.77 12.02L14 13.25',
];
